const useLastOpenedVehicle = (currentSale: any): string | undefined => {
  if (currentSale?.lastOpenedVehicle === true || currentSale?.lastOpenedVehicle === false) {
    return 'first'
  } else {
    return currentSale?.lastOpenedVehicle
  }
}

export default useLastOpenedVehicle
